// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pp-c";
export var backButton = "_pp-4";
export var backIcon = "_pp-5";
export var chevronShortcut = "_pp-6";
export var container = "_pp-1";
export var editor = "_pp-8";
export var editorWrapper = "_pp-7";
export var prefix = "_pp-2";
export var searchIcon = "_pp-3";
export var suffix = "_pp-9";
export var suffixContent = "_pp-a";
export var suffixText = "_pp-b";
export var wrapper = "_pp-0";